import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import TeamSettingsForm from './TeamSettingsForm';
import i18n from 'i18n';

interface TeamSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeTeamId: number;
}

const TeamSettingsModal: React.FC<TeamSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeTeamId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_team_settings.text')}
        entityId={activeTeamId}
        entityIdPropName="teamId"
        FormComponent={TeamSettingsForm}
    />
));

export default TeamSettingsModal;
